import React from 'react';
import { motion } from 'framer-motion';
const OTL_LIST = ['Áreas Protegidas', 'Humedales Continentales', 'Humedales RAMSAR', 'Microcuencas', 'Páramos', 'Planes de Ordenamiento y Manejo de Cuencas Hidrográficas (POMCA)', 'Reservas Forestales de la Ley Segunda de 1959', 'Reservas Forestales Protectoras Naturales', 'Reservas Forestales Protectoras Productoras', 'Zonas de Protección y Desarrollo de los Recursos Naturales Renovables'];
export function OtlList() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="mb-24 bg-bone-dark p-8 md:p-12 lg:p-16" data-id="element-363" data-mp="3vcwfrgizw7xg">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-364" data-mp="3legnvbc58umw">
        <div className="lg:col-span-5" data-id="element-365" data-mp="3qgfr8l7vvrju">
          <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-3" data-id="element-366" data-mp="3qdbbcql237dc">
            Pilar 1 — Proyecto TEFOS
          </span>
          <h3 className="font-serif text-3xl md:text-4xl text-forest leading-tight mb-6" data-id="element-367" data-mp="3gg6ospnat9w0">
            OTL modelados en el marco del Pilar 1 de TEFOS
          </h3>
          <p className="text-charcoal/80 font-light leading-relaxed mb-6" data-id="element-368" data-mp="2215cflp1oy66">
            El Ministerio de Ambiente y Desarrollo Sostenible, apoyado por el
            Banco Mundial, ha avanzado en la modelación de diez Objetos
            Territoriales Legales priorizados por el sector ambiental.
          </p>
          <p className="text-charcoal/80 font-light leading-relaxed" data-id="element-369" data-mp="1o8yz07da15af">
            Estos modelos permiten integrar, en una misma estructura, la
            información jurídica, administrativa y geográfica de cada figura
            territorial. Con ello se fortalece la gestión ambiental, se facilita
            la interoperabilidad entre entidades y se promueve un uso más
            transparente de la información pública.
          </p>
        </div>
        <div className="lg:col-span-7" data-id="element-370" data-mp="15gwcwghv8wss">
          <ol className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-371" data-mp="10kfpjoihqmgr">
            {OTL_LIST.map((item, i) => <motion.li key={item} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.05 * i,
            duration: 0.4
          }} className="flex items-start gap-4 py-3 border-b border-charcoal/10 last:border-0 md:last:border-b md:[&:nth-last-child(-n+2)]:border-0" data-id="element-372" data-mp="1q8l6mqga2awn" data-mpi={i}>
                <span className="font-serif text-clay text-xl leading-none mt-0.5 w-8 flex-none" data-id="element-373" data-mp="17as4vrhe470u">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="text-charcoal font-light leading-snug" data-id="element-374" data-mp="1g8ua6j85pltx">
                  {item}
                </span>
              </motion.li>)}
          </ol>
        </div>
      </div>
    </motion.div>;
}